import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EntityType  {
    _originalTypeClassName = "zERP.BO.EntityType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EntityType.translate = translateService;
}
this.Attributes = [];
this.Children = [];
this.Temporary = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.DefinitionLevel = null;
this.LinkEntity = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
DefinitionLevel:any;
LinkEntity:any;
Attributes:any;
Parent:any;
Children:any;
Temporary:any;
static setAttributes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attributes == null) $this.Attributes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attributes.length > 0) {
                    Domain.EntityType.removeAttributes($this, $this.Attributes[0]);
                }

                Domain.EntityType.addManyAttributes($this, copyItems);
            }
static addManyAttributes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EntityType.addAttributes($this, items[i]);
                }
            }
static addAttributes = ($this, item) => {
                if ($this.Attributes == null) $this.Attributes = [];
                if (item == null || $this.Attributes.indexOf(item) > -1) return;
                $this.Attributes.push(item);
if (item.EntityType != $this) {
Domain.Attribute.setEntityType(item, $this);
}
}
static addRangeAttributes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EntityType.addAttributes($this, item));
            }
static removeAttributes = ($this, item) => {
                if ($this == null || $this.Attributes == null || $this.Attributes.indexOf(item) === -1) return;
                var _index = $this.Attributes.indexOf(item);
                $this.Attributes.splice(_index, 1);
item.EntityType = null;
}
static clearAttributes = ($this) => { $this.Attributes = null; }
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.EntityType.removeChildren(oldValue, $this);
}
Domain.EntityType.addChildren(value, $this);
}
}
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.EntityType.removeChildren($this, $this.Children[0]);
                }

                Domain.EntityType.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EntityType.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
if (item.Parent != $this) {
Domain.EntityType.setParent(item, $this);
}
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EntityType.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
item.Parent = null;
}
static clearChildren = ($this) => { $this.Children = null; }
static setTemporary = ($this, items) => {
                if (items == null) items = [];
                if ($this.Temporary == null) $this.Temporary = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Temporary.length > 0) {
                    Domain.EntityType.removeTemporary($this, $this.Temporary[0]);
                }

                Domain.EntityType.addManyTemporary($this, copyItems);
            }
static addManyTemporary = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EntityType.addTemporary($this, items[i]);
                }
            }
static addTemporary = ($this, item) => {
                if ($this.Temporary == null) $this.Temporary = [];
                if (item == null || $this.Temporary.indexOf(item) > -1) return;
                $this.Temporary.push(item);
}
static addRangeTemporary = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EntityType.addTemporary($this, item));
            }
static removeTemporary = ($this, item) => {
                if ($this == null || $this.Temporary == null || $this.Temporary.indexOf(item) === -1) return;
                var _index = $this.Temporary.indexOf(item);
                $this.Temporary.splice(_index, 1);
}
static clearTemporary = ($this) => { $this.Temporary = null; }

static GetClassName(): any{return "EntityType";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}